import {createContext} from 'react';
import {ReactReduxContextValue} from 'react-redux';

export const AppReduxContext = createContext<ReactReduxContextValue | null>(null);
